<template>
  <div>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading data
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h1 class="report-title mr-5">LAPORAN GIRO BELUM CAIR</h1>
      </div>
      <div class="content mt-2 mb-5">
        <div class="head">
          <table style="width: 100%">
            <tr>
              <td width="20%">Jumlah Giro</td>
              <td width="2%">:</td>
              <td>{{ data.length }}</td>
            </tr>
            <tr>
              <td width="20%">Total Nominal Giro</td>
              <td width="2%">:</td>
              <td>{{ formatCurrency(totalNominalGiro) }}</td>
            </tr>
          </table>
        </div>

        <br />

        <table width="100%" class="table-border">
          <thead>
            <th class="text-center">NOMOR PELUNASAN</th>
            <th class="text-center">NOMOR GIRO</th>
            <th class="text-center">NAMA BANK</th>
            <th class="text-center">NOMINAL GIRO</th>
          </thead>
          <tbody>
            <tr v-for="data in data" :key="data.id">
              <td class="text-center">{{ data.no_pelunasan }}</td>
              <td class="text-center">{{ data.nomor_giro }}</td>
              <td class="text-center">{{ data.nama_bank }}</td>
              <td class="text-center">
                {{ formatCurrency(data.nominal_giro) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    totalNominalGiro() {
      let total = 0;

      this.data.forEach(data => {
        total += data.nominal_giro;
      });

      return total;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchData() {
      this.state.loading = true;

      await axios
        .get(`giro/laporan/giro-belum-cair`)
        .then(res => {
          if (res.data.length === 0) {
            this.state.noData = true;
          } else {
            this.state.noData = false;

            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.report .report-title {
  border-bottom: 1px solid black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.head {
  display: flex;
}

.mr-10 {
  margin-right: 15rem;
}

td.box {
  padding: 0 5px;
  border: 1px solid black;
}

table {
  border-collapse: collapse;
}

tr.separator {
  border-bottom: 1px solid black;
  padding-top: 2px;
  padding-bottom: 2rem;
}

.total {
  vertical-align: top;
  padding-left: 1rem;
}

.table-border,
.table-border th,
.table-border td {
  border: 2px solid black;
  border-collapse: collapse;
}

.table-border td {
  padding: 2px;
}
</style>
